import { isEmpty, sample, shuffle } from "lodash";
import { useEffect } from "react";

const LOREM =
  "fox dogs stars mountains streams valleys skies birds flowers gardens " +
  "children families picnics sunshine lakes fish trees breezes forests " +
  "deer butterflies meadows crickets skies fireflies owls trees squirrels " +
  "quick brown lazy bright peaceful gentle green clear high spring " +
  "joyful warm cool soft misty free ancient rivers clouds rainbows sunshine " +
  "moonlight starlight twilight meadows forests mountains valleys oceans " +
  "beaches islands serene tranquil vibrant colorful peaceful magical mystical";

export const lorem = (c?: number) =>
  shuffle(LOREM.split(" "))
    .slice(0, c || 4)
    .join(" ");

export const randomWord = () => sample(LOREM.split(" "));

export const randomFirstName = () => {
  const names =
    "James Maria David Sarah Michael Emma William Olivia Robert Sofia Thomas " +
    "Isabella Daniel Ava Joseph Mia Christopher Charlotte Andrew Elizabeth " +
    "Noah Aiden Logan Jayden Isaiah Samuel Jeremiah Noah Elijah Lucas " +
    "Sophia Liam Olivia Ethan Isabella Mason Emma Alexander Sophia Benjamin " +
    "Charlotte Lucas Amelia Henry Victoria Sebastian Zoe";
  return sample(names.split(" "));
};

export const randomLastName = () => {
  const names =
    "Smith Garcia Johnson Wilson Brown Davis Moore Lewis Clark " +
    "Walker Hall Allen Young Hernandez King Wright Lopez Hill Scott Green " +
    "Adams Baker Nelson Carter Mitchell Perez Roberts Sanchez Perry Evans " +
    "Turner Phillips Campbell Parker Edwards Collins Stewart Morris Reed " +
    "Cook Morgan Murphy Bailey Cooper Richardson Cox Howard Ward Torres";
  return sample(names.split(" "));
};

export const randomName = () => `${randomFirstName()} ${randomLastName()}`;

export const daysFromNow = (days: number) => {
  const today = new Date();
  today.setDate(today.getDate() + days);
  return today.toISOString().split("T")[0];
};

export const randomBirthdate = (age: number = 18) => {
  const today = new Date();
  const year = today.getFullYear() - age;
  const month = String(Math.floor(Math.random() * 12) + 1).padStart(2, "0");
  const day = String(Math.floor(Math.random() * 28) + 1).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const randomPhone = () => {
  const areaCode = String(Math.floor(Math.random() * 900) + 100).padStart(3, "0");
  const exchange = String(Math.floor(Math.random() * 900) + 100).padStart(3, "0");
  const subscriber = String(Math.floor(Math.random() * 10000) + 1000).padStart(4, "0");
  return `(${areaCode}) ${exchange}-${subscriber}`;
};

export const randomGender = () => sample(["male", "female"]);

(window as any).devToolStack = [];

export const useDevTool = (fn, args = []) => {
  const stack = (window as any).devToolStack;
  const name = new Error().stack.split("\n")[0];
  const item = { name, fn, args };
  const existing = stack.find((item) => item.name === name);
  if (existing) {
    Object.assign(existing, item);
  }

  useEffect(() => {
    stack.push(item);
    return () => stack.pop();
  }, []);
};

export const useDevToolForm = (values, setValue, getValues) => {
  useDevTool(() => {
    Object.entries(values).forEach(([key, value]) => {
      if (isEmpty(getValues(key))) {
        setValue(key, value);
      }
    });
  });
};
